import {
  mergeProductVariantAvailabilityStatuses,
  productVariantAvailabilityStatus,
  type ProductVariantAvailabilityStatus
} from "@swo/shared";
import { nonEmptyArray as NEA } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import type { Semigroup } from "fp-ts/lib/Semigroup";
import type { BundleVariantSelection } from "./BundleVariantSelection";

const productVariantAvailabilityStatusSemigroup: Semigroup<ProductVariantAvailabilityStatus> = {
  concat: (a, b) => {
    return mergeProductVariantAvailabilityStatuses(a, b);
  },
};

export function getBundleSelectionParams(
  currentVariantsState: BundleVariantSelection,
  availabilityMap: Map<string, ProductVariantAvailabilityStatus> | "shopping-not-possible",
) {
  function getBundleAvailability(): ProductVariantAvailabilityStatus | null {
    if (availabilityMap === "shopping-not-possible") {
      return null;
    }

    const availabilities = pipe(
      currentVariantsState,
      NEA.map(_ => availabilityMap.get(_.value.sku) ?? productVariantAvailabilityStatus.outOfStock()),
    );

    return pipe(
      availabilities,
      NEA.foldMap(productVariantAvailabilityStatusSemigroup)(_ => _),
    );
  }

  const availability = getBundleAvailability();

  return {
    availability,
  };
}
